const state = {
  ...window.__initialAppState.global
};

export default state;
